<template>
<div class="chapter">
<div class="inner_page">
<div id="Copyright">
<div class="copy">Copyright © Murray Lee, 2022</div>
<div class="copy1">All rights reserved under International and Pan-American Copyright Conventions. Published by Publerati.</div>
<div class="copy1">This book is a work of fiction. Names, characters, businesses, organizations, places, events, and incidents are either the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events, or locales is entirely coincidental.</div>
<div class="copy1">Cover painting reproduced with permission of Dorset Fine Arts:</div>
<div class="copy-img"><img alt="image" src="images/ufig_1.jpg"/></div>
<div class="copy1">Ningiukulu Teevee<br/>Glittering Walrus, 2019<br/>Etching, Aquatint and Hand Colouring<br/>78 x 121 cm<br/>Cover design by William Oleszczuk<br/>Trade Paperback ISBN: 978-1-7350273-8-8<br/>eISBN: 978-0-9979137-8-1</div>
<div class="copy1">Publerati donates a portion of all sales to help spread literacy. Please learn more at the Publerati website.</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?aa54b594